import React, { useState, useEffect } from "react"
import { nanoid } from "nanoid"

import { AiOutlineFileImage } from "react-icons/ai"

function Ingredients({ ingredients }) {
    const [ filtered, setFiltered ] = useState([])

    useEffect(() => {
        const getFiltered = () => {
            const arr = []
            ingredients?.forEach( item => {
                item?.forEach( content => {
                    arr.push(content)
                })
            })
    
            const unique = [...new Map(arr.map(item => [item.id, item])).values()]
            setFiltered( unique )
        }
        getFiltered()
    }, [ingredients, setFiltered])

    return (
        <section className="container ingredientContainer">
            {
                filtered.map( item => {
                    return  <div key={nanoid()} className="tile ingredientTile">
                        {item.image  
                            ? <img 
                                src={`https://spoonacular.com/cdn/ingredients_500x500/${item.image}`} 
                                alt="Ingredients" />
                            : <AiOutlineFileImage size="100px" />
                        }
                        <p>{item.name}</p>
                    </div>
                })
            }
        </section>
    )
}

export default Ingredients
